export default __webpack_public_path__ + "static/media/team76.7111a0ab.JPG";